module.exports = __webpack_public_path__ + "img/belgium-leukaemia-male.0fbb1ea6.png";